import { useState, useEffect } from 'react';
import { fetchGroups, updatePlayer } from '../api'
import CreateLogin from '../components/CreateLogin';
import Login from '../components/Login';
import GroupListItem from '../components/GroupListItem';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Loading from '../components/Loading';

/**
 * Dashboard Page
 *
 * @constructor
 */
const Dashboard = () => {
  const [ groups, setGroups ] = useState([]);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ showLogout, setShowLogout ] = useState(false);
  const [ showLogin, setShowLogin ] = useState(false);
  const [ showCreateLogin, setShowCreateLogin ] = useState(false);
  const [ initStarted, setInitStarted ] = useState(false);

  let player = JSON.parse(localStorage.getItem('player'));

  // The stored player should always exist at this point
  if (!player) {
    window.location = '/';
    return;
  }

  /**
   * Initialize
   */
  useEffect(() => {
    if (!initStarted) {
      setInitStarted(true);
      fetchGroups(player).then((groups) => {
        console.log('player: ', player);
        console.log('groups: ', groups);
        if (groups.success === false) {
          console.error('Failed to fetch groups: ', groups.error);

          // If the player was not found, remove the player from local storage and redirect to the home page
          if (groups.error === 'Player not found') {
            localStorage.removeItem('player');
            window.location = '/';
          }
          return;
        }

        // Check local player groups and update player in db if necessary
        const groupIds = groups.map((group) => group.guid);
        if (JSON.stringify(player.groups) !== JSON.stringify(groupIds)) {
          player.groups = groupIds;
          localStorage.setItem('player', JSON.stringify(player));
          updatePlayer(player).then((result) => {
            if (result.success === false) {
              console.error('Failed to update player: ', result.error);
            }
          });
        }

        setGroups(groups);
        setIsLoading(false);
      });

      // Is registered player?
      if (player.email) {
        setShowLogout(true);
      } else {
        setShowCreateLogin(true);
      }
    }
  }, []);

  /**
   * onLoginLinkClick
   *
   * Handler for when the "I have a login" link is clicked. Toggles between the login and create login components.
   */
  const onLoginLinkClick = () => {
    setShowCreateLogin(false);
    setShowLogin(true);
  }

  /**
   * onCreateLinkClick
   *
   * Handler for when the "Create Login" link is clicked. Toggles between the login and create login components.
   */
  const onCreateLinkClick = () => {
    setShowLogin(false);
    setShowCreateLogin(true);
  }

  if (isLoading) {
    return (
      <div className="page-wrap">
        <Header/>
        <div className="dashboard-page">
          <Loading/>
        </div>
        <Footer/>
      </div>
    )
  } else {
    return (
      <div className="page-wrap">
        <Header/>
        <div className="dashboard-page">

          {/*<div className="title">My Games</div>*/}
          <div className="group-list">
            {groups.map((group, index) => (
              <GroupListItem key={index} group={group} answered_today={group.answered_today}/>
            ))}
          </div>
          {player.groups.length < process.env.REACT_APP_MAX_GROUPS ?
            <button className="main-btn new-button" onClick={() => window.location = '/subjects'}>New Game</button>
            :
            <div className="max-groups-msg">You have reached the maximum number of games. To start a new game, delete an existing one.</div>
          }
          {!showLogout &&
            <div>
              {showCreateLogin &&
                <div>
                  <CreateLogin/>
                  <div className="link-button-wrap">
                    <span className="link-button login-link" onClick={onLoginLinkClick}>I have a login</span>
                  </div>
                </div>
              }
              {showLogin &&
                <Login showCreateLink="true" onCreateLinkClick={onCreateLinkClick}/>
              }
            </div>
          }
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Dashboard;
